import React, { createContext, useContext, useEffect, useState } from "react";
import { STRINGS } from "../lib/i18n";

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("nb_lang") || "en");

  useEffect(() => {
    const dir = STRINGS[lang].dir;
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
    document.body.setAttribute("dir", dir);
    localStorage.setItem("nb_lang", lang);
  }, [lang]);

  const t = (k) => STRINGS[lang][k] ?? k;
  const toggle = () => setLang((l) => (l === "en" ? "ar" : "en"));

  return (
    <LangCtx.Provider value={{ lang, setLang, toggle, t, isRTL: lang === "ar" }}>
      {children}
    </LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);
